import queryString from "query-string";

export const qsStringify = (args: {
  [key: string]: string | string[] | number | null | undefined;
}): string => {
  return queryString.stringify(args, {
    arrayFormat: "bracket",
  });
};
